module.exports = __webpack_public_path__ + "static/media/arrow-alt-right.e8b06d72.svg";